import React from "react";
import crest from "../images/castleknock_logo.png";

export default function TopBar({ routeBusy }) {
  return (
    <header className="topbar">
      <div className="topbarInner">
        <div className="brand">
          <div className="crestFrame" aria-hidden="true">
            <img className="crestImg" src={crest} alt="" />
            <div className="crestGlow" />
          </div>

          <div className="brandText">
            <div className="brandName">Castleknock GAA</div>
            <div className="brandTag">An Club Cliste</div>
          </div>
        </div>

      </div>

      <div className="routeLine" aria-hidden="true">
        <div className={`routeLineBar ${routeBusy ? "on" : ""}`} />
      </div>
    </header>
  );
}
